var icon = require('vue-svgicon')
icon.register({
  'ks-icon-map-marker': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M64 61.9a10.5 10.5 0 1 1 10.5-10.5A10.5 10.5 0 0 1 64 61.9M64 22a29.4 29.4 0 0 0-29.4 29.4C34.6 73.45 64 106 64 106s29.4-32.55 29.4-54.6A29.4 29.4 0 0 0 64 22z"/>'
  }
})
